import { log } from "@kiwicom/nitro/lib/services/log/logger"

import { RefundOffersInput } from "../../../../../../../records/bookingInput"
import { RefundOfferType, RefundOffers, REFUND_OFFER_TYPE } from "../../refundConsts"
import {
  RefundModule,
  ErrorAction,
} from "../../../../../../../services/tracking/constants/trackingEvents"
import { createEventLogUnified } from "../../../../../../../services/tracking/createEventLogUnified"

const isOfferTypeExpected = (type: RefundOfferType): boolean => {
  if (Object.values(REFUND_OFFER_TYPE).includes(type)) return true

  void log(createEventLogUnified(RefundModule, ErrorAction.invalidData), {
    detail: "unexpected refund offer type",
    refundOfferType: type,
  })
  return false
}

const mapperRefundOffers = (refundOffersInput: RefundOffersInput): RefundOffers =>
  refundOffersInput.filter((offer) => isOfferTypeExpected(offer.type))

export default mapperRefundOffers
